import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/game-view/')({
  beforeLoad: ({ params, search }) => {
    throw redirect({ params, search, to: '/game-view/game-clips' });
  },
});
